<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="城市公司：">
            <el-select v-model="query.cityId" placeholder="请选择" size="small" clearable filterable>
              <el-option v-for="item in cityCompanyOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <!-- REQ-2026-751517 返工（产品 2026-09-09 截图批注）：商户号的导出 / 模板 / 导入放在这里、
               「+ 新增账套」左边，而且是**全量**：一个筛选条件都不传（不传 channelType、不传 cityCompanyId）。
               二级页 payMerchant.vue 里那三个是按当前渠道的，保留给单渠道运维用，两处调同一批接口。
               后端 export() 里 channelType 是可选条件，不传就是全量，不用改。 -->
          <el-button type="primary" size="mini" plain :loading="merchantExportLoading" @click="handleMerchantExport">导出商户号</el-button>
          <el-button type="primary" size="mini" plain @click="handleMerchantTemplate">下载导入模板</el-button>
          <el-upload style="display:inline-block;margin:0 8px" action="#" :show-file-list="false"
            :http-request="handleMerchantImport" accept=".xlsx,.xls">
            <el-button type="primary" size="mini" plain :loading="merchantImportLoading">批量导入商户号</el-button>
          </el-upload>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新增账套</el-button>
          <el-button type="primary" size="mini" @click="handleCreatejigou" icon="el-icon-plus">新增机构</el-button>
          <el-button type="primary"  size="mini" @click="handlePayMerchant(row,'allinpay')" icon="el-icon-plus">银行卡配置</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="id " prop="id" align="center"  width="80"/>
        <el-table-column label="城市公司 " prop="cityCompanyListVO[0].name" align="center" /> 
        <el-table-column label="机构" align="center">
          <template slot-scope="{row}">
            {{ getMarketingOrganName(row.idMarketingOrgan) }}
          </template>
        </el-table-column>   
        <!-- <el-table-column label="msgKey " prop="msgKey" align="center" /> -->
        <!-- <el-table-column label="ruanCertificate " prop="ruanCertificate" align="center" show-overflow-tooltip /> -->
        <!-- <el-table-column label="authorisationUrl " prop="authorisationUrl" align="center" show-overflow-tooltip /> -->
        <!-- <el-table-column label="appKey " prop="appKey" align="center" /> -->
        <!-- <el-table-column label="appSecret " prop="appSecret" align="center" /> -->
        <el-table-column label="是否是旧系统账套 " align="center" >
          <template slot-scope="{row}">
            {{row.isUseOrder?'是':'否'}}
          </template>
        </el-table-column>
        <el-table-column label="是否教育公司用于收学费 " align="center" >
          <template slot-scope="{row}">
            {{row.isUseEducation?'是':'否'}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="用友token" align="center">
          <template slot-scope="{row}">
            {{row.refreshContent1 && row.refreshContent1.result?'成功':'失败'}}
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="用友Ticket" align="center">
          <template slot-scope="{row}">
            {{row.refreshContent2?'成功':'失败'}}
          </template>
        </el-table-column> -->
      
        <el-table-column label="状态" prop="isEnable" align="center" width="100">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" align="center" width="160" />
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handlePay(row)">支付配置</el-button>
            <el-button type="text" @click="handleUpdate1(row)">机构编辑</el-button>
            <el-button type="text" @click="handlePayMerchant(row,'wechat')">微信直连配置</el-button>
            <!-- <el-button type="text" @click="handlePayMerchant(row,'allinpay')">银行卡配置</el-button> -->
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <youAccount-add ref="youAccountAdd" :cityCompanyOptions="cityCompanyOptions" @created="doQueryList({})" />
    <import-result-dialog ref="importResultDialog" />
    <youAccount-add1 ref="youAccountAdd1" :cityCompanyOptions="cityCompanyOptions" :marketingOrganOptions="marketingOrganOptions" @created="doQueryList({})" />
  </div>
</template>

<script>
import youAccountAdd from './add'
import youAccountAdd1 from './add1.vue'
import yongyouConfigApi from '@/api/config/yongyouConfig'
import Pagination from '@/components/Pagination'
import cityCompanyApi from '@/api/sys/cityCompany'
import sysToolsApi from '@/api/sys/tools'
import importResultDialog from './importResultDialog.vue'
export default {
  components: {
    Pagination,
    youAccountAdd,
    youAccountAdd1,
    importResultDialog
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      cityCompanyOptions: [],
      marketingOrganOptions: [],
      merchantExportLoading: false,
      merchantImportLoading: false
    }
  },
  created() {
    this.getCityCompany()
    this.getMarketingOrgan()
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    // region REQ-2026-751517 商户号全量导出 / 模板 / 导入
    //
    // 🔴 2026-09-22 修正数据源（BUG-2026-370483 / 159264 / 664209）：
    //    这三个按钮原来调的是 payMerchantApi（`/pay/payMerchant/tee`，数据源 pay_merchant），
    //    而本页是「城市公司账套配置」，列表用的是 yongyouConfigApi、数据源 yongyou_config_pay。
    //    **按钮和它所在的页面不是同一个数据源**，所以导出只有 4 行（pay_merchant 的全部行数）、
    //    列头也是支付商户那一套。处理函数当初是从 payMerchant.vue 复制过来的，API 没跟着换。
    //
    //    ⚠️ payMerchant.vue 里同样的三个调用是**对的**，别一起改——那个页面管的就是 pay_merchant。
    /** 导出全量：后端不分页导全量，不传任何筛选参数（本页 query 是账套列表的筛选，与商户号无关） */
    handleMerchantExport() {
      this.merchantExportLoading = true
      yongyouConfigApi.configPayExport().finally(() => {
        this.merchantExportLoading = false
      })
    },
    handleMerchantTemplate() {
      yongyouConfigApi.configPayTemplate()
    },
    /** 后端逐行按城市公司名匹配、合法的落库非法的只记原因，结果必须摊给运营看，不能只看有没有报错 */
    handleMerchantImport(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      this.merchantImportLoading = true
      yongyouConfigApi.configPayImport(formData).then(({ data }) => {
        this.$refs.importResultDialog.show(data)
        if (data && data.failCount > 0) {
          this.$message.warning(`导入完成，有 ${data.failCount} 行未导入`)
        } else {
          this.$message.success('导入完成')
        }
      }).finally(() => {
        this.merchantImportLoading = false
      })
    },
    // endregion
    getMarketingOrganName(val) {
      if (!val) return ''
      const strVal = String(val)
      let idPart = null
      let codePart = null
      if (strVal.includes('-')) {
        const parts = strVal.split('-')
        idPart = parts[0]
        codePart = parts[1]
      } else {
        idPart = strVal
      }
      if (!this.marketingOrganOptions || this.marketingOrganOptions.length === 0) return strVal
      const found = this.marketingOrganOptions.find(o => String(o.ID) === String(idPart) || (codePart && String(o.Code) === String(codePart)))
      return found ? found.Name : strVal
    },
    getMarketingOrgan() {
      sysToolsApi.getMarketingOrgan({ id: 1 }).then(res => {
        this.marketingOrganOptions = res.data
      })
    },
    handlePay(row) {
     this.$emit('handleShow',row,2) 
    },
    handlePayMerchant(row, channelType) {
     this.$emit('handleShow',row,3, channelType) 
    },
    getCityCompany() {
      cityCompanyApi.fetchList({ pageNo: 1, pageSize: 1000, state: 1 }).then(res => {
        this.cityCompanyOptions = res.data.list
      })
    },
    handleFilter() {
      this.query = {}
      this.cityId = ''
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        // 'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }

      this.listLoading = true
      return yongyouConfigApi.fetchList(this.query)
        .then(data => {
          let { list, total } = data.data;
          list.forEach(item => {
            item.refreshContent1 = item.refreshContent1 ? JSON.parse(item.refreshContent1) : ''
            // item.refreshContent2 = item.refreshContent2 ? JSON.parse(item.refreshContent2) : ''
          });
          this.list = list
          this.total = total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => yongyouConfigApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => yongyouConfigApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      yongyouConfigApi.setIsEnable({ id: row.id, state: row.state }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.youAccountAdd.handleCreate(this.total)
    },
    handleCreatejigou() {
      this.$refs.youAccountAdd1.handleCreatejigou(this.total)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.youAccountShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.youAccountAdd.handleUpdate(row)
    },
    handleUpdate1(row) {
      this.$refs.youAccountAdd1.handleUpdate(row)
    }
  }
}
</script>
